import styled from 'styled-components';
import { appTheme } from '../../theme';
import { Link } from 'react-router-dom';

const PageLink = styled(Link)`
  font-size: ${props => props.fontSize || '0.8em'};
  margin: ${appTheme.spacing.default} 0;
  text-align: center;
`;

export default PageLink;



// WEBPACK FOOTER //
// ./src/modules/common/PageLink.js